export default __webpack_public_path__ + "static/media/cylinder-geometry.60cb12b4.svg";